// extracted by mini-css-extract-plugin
module.exports =  {"layout-content":"layout-content--GFbmR","layoutContent":"layout-content--GFbmR","inner":"inner--xg8MN"};